<app-alerts />

<section class="box-border block rounded-sm text-center">
  <div class="mx-auto box-border w-full rounded-sm bg-[#02003c] p-4 text-left">
    <div class="grid grid-cols-2 gap-4">
      <div class="col-span-2">
        <aside class="text-white">Numer karty</aside>
        <div
          class="rounded-xs bg-white p-1"
          id="payu-card-number"></div>
      </div>

      <div>
        <aside class="text-white">Data ważności</aside>
        <div
          class="rounded-xs bg-white p-1"
          id="payu-card-date"></div>
      </div>

      <div>
        <aside class="text-white">CVV</aside>
        <div
          class="rounded-xs bg-white p-1"
          id="payu-card-cvv"></div>
      </div>
    </div>
  </div>
</section>

<div class="mt-4 flex items-center justify-center gap-1">
  <div>Płatność przeprowadzona bezpiecznie przez</div>
  <app-image-thumbnail size="sm">
    <img
      [fill]="true"
      [ngSrc]="AssetImage.PayU | assetImageUrl"
      alt="PayU"
      class="object-contain" />
  </app-image-thumbnail>
</div>

@if (withPrivacyPolicy()) {
  <div class="mt-4 overflow-y-auto text-xs text-gray-400">
    <app-payu-privacy-policy />
  </div>
}
